import { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'ai-coach',
        name: 'AI Coaches for Reviews and Training',
        description:
            'Upload company policies, values and career matrixes, then let interactive AI coaches help managers prepare for tough conversations, or write more relevant performance reviews',
        descriptionLong: (
            <>
                <h3>AI-driven manager coaching, AI guidance for your company's reviews</h3>
                <p>
                    <b>Help prepare for tough conversations</b>
                    <br />
                    New managers will face tricky situations, and AI can help prepare. But external tools like ChatGPT
                    won't have access to your company approach, values or policies — and you'd not want staff sharing
                    these externally unsupervised. Using SI, you can now upload your policies and resources, and then
                    offer AI-based training such as role-playing pay raise request, preparing for tricky discussions, or
                    collecting thoughts before reporting misconduct. Pre-uploaded resources ensure everything remains
                    true to your company approach.
                </p>
                <p>
                    <b>Guide reviews holistically</b>
                    <br />
                    In addition to our existing writing assistants, you can now guide managers and staff with
                    interactive coaches. These can make suggestions by comparing the current writing with previous
                    feedback and objectives, and ensure the review matches your career matrix or general world knowledge
                    about roles. See screenshot for an example.
                </p>
                <p>
                    Please reach out to{' '}
                    <a href="mailto:product@small-improvements.com">
                        <b>product@small-improvements.com</b>
                    </a>{' '}
                    to join this Early Access Program.
                </p>
            </>
        ),
        type: 'announcement',
        imgSrc: require('./images/ai-coach.png'),
    },
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'admin-navigation-refresh',
        name: 'Easy Admin Navigation',
        description: 'We’ll make it easier to reach all admin screens, removing the need for the "Admin Toggle Button"',
        descriptionLong: (
            <p>
                Many customers told us that toggling the navigation from “employee” to “admin” causes too much friction.
                We are removing the toggle, adding administration screens into the feature tabs.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_adminNavigationRefresh',
        imgSrc: require('./images/new-admin-navigation.png'),
    },
    {
        id: 'review-outlier-detection',
        name: 'Review Outlier Detection',
        description: 'Spot statistically significant rating patterns across groups in performance reviews',
        descriptionLong: (
            <p>
                When you're managing hundreds of performance reviews, hidden bias can slip through unnoticed. Our new
                Outlier Detection feature automatically surfaces statistically significant rating patterns across groups
                — by location, tenure, gender, team, manager, and more — so you can spot fairness issues in seconds.
                Instead of manually combing through spreadsheets, you'll see exactly where ratings deviate from the
                cycle average and why it matters, backed by data science best practices.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewTableAnomaly',
        imgSrc: require('./images/review-outlier-detection.png'),
    },
];
